import NewsModel from '../Apis/News.js'
import Controller from './Controller.js';

export default class NewsController extends Controller {

    constructor() {
        super(new NewsModel());
    }


}